module.exports = __webpack_public_path__ + "static/media/card3_8.79c5938e.png";